import { deleteCategory as deleteCategoryRequest, saveCategory } from "../../api/categories.js";
import { Delete } from "@mui/icons-material";
import { Box, Button, CircularProgress, IconButton, Switch, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal, NumberInput, TextInput, UploadImage } from "../../../../shared/ui/common/index.js";
import Confirm from "../../../../shared/ui/modals/Confirm.jsx";
import { logout } from "../../../../shared/state/slices/user.js";
const CategoryModal = ({
  open,
  close,
  data = {},
  forEdit,
  setAllRows,
  allRows,
}) => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.user);
  const [selectedProductImage, setselectedProductImage] = useState();
  const { userPermissions } = useSelector((state) => state.relationals);
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [prevData, setPrevData] = useState({});
  const [openDelete, setOpenDelete] = useState(false);

  // set data
  useEffect(() => {
    if (forEdit) {
      setPrevData({
        ...data,
        /*     parentId: allRows.find((cat) => cat.id === data.parentId), */
      });
    } else {
      resetData();
    }
  }, [allRows, data, forEdit]);
  const resetData = () => {
    setPrevData({});
    setselectedProductImage();
  };
  const deleteCategory = () => {
    if (data) {
      setLoading(true);
      deleteCategoryRequest(data.id, token)
        .then((res) => {
          setLoading(false);
          setOpenDelete(false);
          var temp = [...allRows];
          var newData = temp.filter((item) => item.id !== data.id);
          setAllRows(newData);
          close();
          toast.success("با موفقیت حذف شد");
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.response?.data?.message);
          setOpenDelete(false);
          if (err.response.status === 401) {
            dispatch(logout());
          }
        });
    }
  };

  const editItem = () => {
    var a = location?.hash ? location?.hash?.slice(1).split(",") : [];
    const formData = new FormData();
    if (data.link) formData.append("link", data.link);
    if (prevData?.parentId || location?.hash)
      formData.append(
        "parentId",
        prevData?.parentId ? prevData?.parentId : a[a?.length - 1]
      );

    formData.append("priority", prevData?.priority);
    formData.append("title", prevData?.title);
    formData.append("description", prevData?.description);
    if (prevData?.avatar) formData.append("files", prevData?.avatar);
    if (selectedProductImage)
      formData.append("fromGallery", selectedProductImage);
    formData.append("active", prevData?.active ? true : false);
    if (prevData?.bronzeCost)
      formData.append("bronzeCost", prevData?.bronzeCost || null);
    if (prevData?.silverCost)
      formData.append("silverCost", prevData?.silverCost || null);
    if (prevData?.goldCost)
      formData.append("goldCost", prevData?.goldCost || null);
    if (forEdit) {
      formData.append("id", prevData?.id);
    }
    var temp = [...allRows];

    setLoading(true);
    if (forEdit) {
      saveCategory(formData, token, true)
        .then((res) => {
          setLoading(false);
          toast.success("با موفقیت ویرایش شد");
          var index = temp.findIndex((item) => item.id === data.id);
          temp[index] = res.data.data;
          setAllRows(temp);
          close();
          resetData();
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.response?.data?.message);

          if (err.response.status === 401) {
            dispatch(logout());
          }
        });
    } else {
      saveCategory(formData, token, false)
        .then((res) => {
          temp.unshift(res.data.data);

          setAllRows(temp);
          setLoading(false);
          toast.success("با موفقیت اضافه شد");
          close();
          resetData();
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.response?.data?.message);

          if (err.response.status === 401) {
            dispatch(logout());
          }
        });
    }
  };
  return (
    <Modal
      open={open}
      close={() => {
        close();
        resetData();
      }}
      title={` ${forEdit ? "ویرایش" : "افزودن"}  دسته بندی 
    `}
    >
      <TextInput
        label="نام دسته بندی "
        change={(e) => setPrevData({ ...prevData, title: e })}
        currentValue={prevData?.title}
      />
      <NumberInput
        label="اولویت"
        change={(e) => setPrevData({ ...prevData, priority: e })}
        value={prevData?.priority}
      />
      {/*     <Dropdown

        value={allRows?.find((item) => item.id === prevData?.parentId)}
        change={(e) => setPrevData({ ...prevData, parentId: e?.id })}
        data={allRows}
        title="والد دسته بندی"
        emptyValue={true}
      /> */}
      <TextField
        multiline
        label="توضیحات"
        value={prevData?.description ?? ""}
        onChange={(e) =>
          setPrevData({ ...prevData, description: e.target.value })
        }
        sx={{ width: "100%" }}
        rows={2}
      />
      <div className="flex flex-wrap items-center gap-3">
        {" "}
        <UploadImage
          file={prevData?.avatar}
          change={(e) => setPrevData({ ...prevData, avatar: e })}
          address={data.galleryId ? data.galleryId : false}
          selectedProductImage={selectedProductImage}
          setselectedProductImage={setselectedProductImage}
        />
        <span>فعال/غیر فعال : </span>
        <Switch
          checked={Boolean(prevData?.active)}
          onChange={(e) =>
            setPrevData({ ...prevData, active: !prevData?.active })
          }
        />
      </div>
      <div className="flex flex-wrap gap-4 items-center">
        <TextInput
          label="قیمت برنز"
          change={(e) => setPrevData({ ...prevData, bronzeCost: e })}
          currentValue={prevData?.bronzeCost}
        />
        <TextInput
          label="قیمت نقره ای "
          change={(e) => setPrevData({ ...prevData, silverCost: e })}
          currentValue={prevData?.silverCost}
        />
        <TextInput
          label="قیمت طلایی"
          change={(e) => setPrevData({ ...prevData, goldCost: e })}
          currentValue={prevData?.goldCost}
        />
      </div>
      <Box sx={{ display: "flex" }}>
        {forEdit && (
          <IconButton onClick={() => setOpenDelete(true)}>
            <Delete color="error" />
          </IconButton>
        )}
        <div style={{ flexGrow: 1 }} />
        <Button
          variant="contained"
          color="primary"
          onClick={editItem}
          disabled={loading}
        >
          {loading ? <CircularProgress /> : <>ثبت اطلاعات</>}
        </Button>
      </Box>
      <Confirm
        message="آیا از حذف این دسته بندی اطمینان دارید؟"
        close={() => setOpenDelete(false)}
        submit={deleteCategory}
        open={openDelete}
      />
    </Modal>
  );
};

export default CategoryModal;
